import { useEffect } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import type { ExperienceFormData } from '../components/ExperienceFormFields';
import type { Experience } from '../types/experience.types';
import { DEFAULT_FORM_VALUES, toEditValues } from '../components/ExperienceFormDialog.utils';

interface UseExperienceFormReturn extends UseFormReturn<ExperienceFormData> {
  isOngoing: boolean;
  isFullTime: boolean;
  isContractor: boolean;
  continuous: boolean;
  isGig: boolean;
}

export function useExperienceForm(
  mode: 'create' | 'edit',
  experience?: Experience | null
): UseExperienceFormReturn {
  const form = useForm<ExperienceFormData>({ defaultValues: DEFAULT_FORM_VALUES });
  const { reset, watch } = form;

  useEffect(() => {
    if (mode === 'edit' && experience) reset(toEditValues(experience));
    else if (mode === 'create') reset(DEFAULT_FORM_VALUES);
  }, [experience, mode, reset]);

  const isOngoing = watch('isOngoing');
  const isFullTime = watch('isFullTime');
  const isContractor = watch('isContractor');
  const continuous = watch('continuous');
  const isGig = watch('isGig');

  return { ...form, isOngoing, isFullTime, isContractor, continuous, isGig };
}
